module.exports = __webpack_public_path__ + "img/5.474b6429.png";